import { useEffect, useRef } from 'react';

/**
 * 监听容器尺寸变化
 */
export const useResize = (
  containerRef: React.RefObject<HTMLDivElement>,
  onResize: (radio: {
    xRadio: number;
    yRadio: number;
    width: number;
    height: number;
    originWidth: number;
    originHeight: number;
  }) => void,
) => {
  const size = useRef({ width: 0, height: 0 });
  const radio = useRef({ xRadio: 1, yRadio: 1 });

  // 监听尺寸变更
  useEffect(() => {
    if (!containerRef.current) return;
    const resizeObserver = new ResizeObserver((entries) => {
      for (const entry of entries) {
        const { width, height } = entry.contentRect;
        if (!size.current.width) {
          size.current.width = width;
        }
        if (!size.current.height) {
          size.current.height = height;
        }
        const xRadio = width ? width / size.current.width : 1;
        const yRadio = height ? height / size.current.height : 1;
        // 尺寸没有变化
        const sizeNoChange =
          width === size.current.width && height === size.current.height;
        // 比例没有变化
        const radioNoChange =
          xRadio === radio.current.xRadio && yRadio === radio.current.yRadio;

        if (sizeNoChange && radioNoChange) {
          return;
        }

        radio.current = { xRadio, yRadio };
        onResize({
          xRadio,
          yRadio,
          width,
          height,
          originWidth: size.current.width,
          originHeight: size.current.height,
        });
        size.current = { width, height };
      }
    });
    resizeObserver.observe(containerRef.current);
    return () => {
      if (!containerRef.current) return;
      resizeObserver.unobserve(containerRef.current as Element);
    };
  }, [onResize]);
  return () => {
    radio.current = { xRadio: 1, yRadio: 1 };
    size.current = { width: 0, height: 0 };
  };
};
